import { createRoot } from "react-dom/client";
import App from "./App";

import "@buzzeasy/shared-frontend-utilities/extensions";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById("root")!).render(<App />);
